import type { QueryClient } from "@tanstack/react-query";
import { clearClarityOneCustomerQueryCache } from "@/lib/clarityOneQueryCache";

export const CLARITY_ONE_HOME_PATH = "/home";

const startedImpersonationTokens = new Set<string>();

export function resetImpersonationVerifyStartsForTests(): void {
  startedImpersonationTokens.clear();
}

export type ImpersonationVerifyGate = {
  token: string;
  alreadyStarted: boolean;
  isPending: boolean;
  isSuccess: boolean;
  isError: boolean;
};

/** Verify the one-time token at most once, including React Strict Mode remounts. */
export function shouldStartImpersonationVerify(gate: ImpersonationVerifyGate): boolean {
  if (gate.alreadyStarted) return false;
  if (startedImpersonationTokens.has(gate.token)) return false;
  if (gate.isPending || gate.isSuccess || gate.isError) return false;
  return gate.token.length > 10;
}

export function markImpersonationVerifyStarted(token: string): boolean {
  if (startedImpersonationTokens.has(token)) return false;
  startedImpersonationTokens.add(token);
  return true;
}

/**
 * After the server has set the Clarity One cookie, drop stale customer caches and
 * replace the impersonation URL with a full document load of /home.
 */
export function completeSuccessfulImpersonationHandoff(
  queryClient: QueryClient,
  navigate: (url: string) => void = (url) => {
    window.location.replace(url);
  },
): void {
  clearClarityOneCustomerQueryCache(queryClient);
  navigate(CLARITY_ONE_HOME_PATH);
}
